import axios from 'axios';
import {getToken} from '@/utils/auth';

const AUTH_TOKEN = getToken();
const baseURL = `${process.env.VUE_APP_BASE_URI}/v2/admin`;

const instance = axios.create({
    baseURL
});

instance.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;

const setAuthHeaderToken = token => {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export default instance;
export { baseURL, AUTH_TOKEN, setAuthHeaderToken };
